module.exports = __webpack_public_path__ + "static/img/1.a69fb00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/weierli/1.png
// module id = Rz8b
// module chunks = 19